export const MeditationSessionInput = [
  {
    label: "Meditation Session Name",
    type: "text",
    placeholder: "Enter meditation session name",
    valueKey: "name",
    defaultValue: "Name not found",
    disabled: true,
  },
  {
    label: "Meditation Type",
    type: "select",
    options: ["Mindfulness"],
    valueKey: "type",
    defaultValue: "Select meditation type",
    disabled: true,
  },
  {
    label: "Time Allotted (Minutes)",
    type: "text",
    placeholder: "Enter time allotted in minutes",
    valueKey: "time_allotted_minutes",
    defaultValue: "Minutes not found",
    disabled: true,
  },
  {
    label: "Description",
    type: "textarea",
    placeholder: "Enter meditation description",
    valueKey: "description",
    defaultValue: "Description not found",
    disabled: true,
  },
  {
    label: "Cultural Background Info",
    type: "textarea",
    placeholder: "Enter cultural background info",
    valueKey: "cultural_background_info",
    defaultValue: "Cultural background info not found",
    disabled: true,
  },
  {
    label: "Benefits",
    type: "text",
    placeholder: "Enter benefits",
    valueKey: "benefits",
    defaultValue: "Benefits not found",
    disabled: true,
  },
  {
    label: "Skill Level",
    type: "select",
    options: ["Beginner", "Intermediate", "Advanced"],
    valueKey: "skill_level",
    defaultValue: "Select skill level",
    disabled: true,
  },
  {
    label: "Recommended Time of Day",
    type: "text",
    placeholder: "Enter recommended time of day",
    valueKey: "recommended_time_of_day",
    defaultValue: "Recommended time not found",
    disabled: true,
  },
  {
    label: "Tags",
    type: "text",
    placeholder: "Enter tags",
    valueKey: "tags",
    defaultValue: "Tags not found",
    disabled: true,
  },
  {
    label: "Image URL",
    type: "text",
    placeholder: "Enter image URL",
    valueKey: "cover_image_url",
    disabled: true,
  },
];
